












import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "EmptyContent",
  components: { BaseImage },
  props: {
    imgSrc: { type: String },
    imgAlt: { type: String },
    text: { type: String as PropType<TranslateResult | string>, default: "" },
  },
});
